<template>
  <!-- <div class="card kpiChart" style="margin-bottom:15px">
    <div class="card-header" style="padding-top:0px">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="d-flex" style>
            <h4 class="card-title companyProfileTabulatorTitle">KPI Graph</h4>
            <div
              style="margin-left: 5px; margin-top: auto;margin-bottom: auto;"
              v-tooltip.top-end="toolTipInfo"
            >
              <img src="static/img/graphInfo.svg" class />
            </div>
          </div>
        </div>
        <div v-if="tractionLastUpdatedDate.length>0">
          <div
            class="card-title companyProfileTabulatorTitle"
            style="font-size: 12px"
          >Last updated date : {{tractionLastUpdatedDate}}</div>
        </div>
      </div>
    </div>
    <div class="card-body" style="padding-top:0px">
      <chartjs-line :chartData="chartData" :chartOptions="chartOptions" :style="lineChartStyle"></chartjs-line>
    </div>
  </div>-->
  <div class="kpiChart">
    <div class="d-flex" style="padding: 0px 0px 15px 20px;">
      <div style="margin-top: auto;margin-bottom: auto;">
        <div class="kpiChartTitle">Customer Growth</div>
      </div>
      <div
        class="d-flex justify-content-center"
        style="margin-left: 5px;"
        v-tooltip.top-end="toolTipInfo"
      >
        <img src="static/img/graphInfo.svg" class />
      </div>
    </div>
    <div class="card-body" style="padding-top:0px">
      <chartjs-line :chartData="chartData" :chartOptions="chartOptions" :style="lineChartStyle"></chartjs-line>
    </div>
  </div>
</template>
<script>
import { vals, formatCurrency } from "../../../util";
import { Select, Option } from "element-ui";
import { ChartjsLineCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
import ChartjsLine from "../../Chartjs/ChartjsLine";

const MONTH = "month";
const MONTH_FORMAT = "MMM YYYY";
const YEAR = "year";
const YEAR_FORMAT = "YYYY";
const QUARTER = "quarter";
const QUARTER_FORMAT = "[Q]Q YYYY";
const DAY = "day";
const DAY_FORMAT = "ll";
export default {
  name: "churnKpiChart",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsLineCard,
    ChartjsLine,
  },
  computed: {
    ...mapGetters("charts", ["tractionLastUpdatedDate"]),
    ...mapGetters("user", ["currency"]),
    chartUnit() {
      const self = this;
      // temp solution: do quarters
      // setup our time tick steps correctly based on data points
      switch (self.dateUnit) {
        case MONTH:
          // return month format
          return {
            tooltipFormat: MONTH_FORMAT,
            round: MONTH,
            unit: MONTH,
            displayFormats: {
              month: MONTH_FORMAT,
            },
          };
        case YEAR:
          // return year format
          return {
            tooltipFormat: YEAR_FORMAT,
            round: YEAR,
            unit: YEAR,
            displayFormats: {
              year: YEAR_FORMAT,
            },
          };
        case QUARTER:
          return {
            tooltipFormat: QUARTER_FORMAT,
            round: QUARTER,
            unit: QUARTER,
            displayFormats: {
              quarter: QUARTER_FORMAT,
            },
          };
        case DAY:
          return {
            tooltipFormat: DAY_FORMAT,
            round: DAY,
            unit: DAY,
            displayFormats: {
              day: DAY_FORMAT,
            },
          };
        default:
          return {};
      }
    },
    chartData() {
      const self = this;
      let kpiInfo = this.$store.getters["charts/churnKpiGraphData"](
        this.$route.params.ucid
      );
      self.dateUnit = DAY;
      let customersData = _.zipWith(
        kpiInfo.customers_t,
        kpiInfo.customers,
        function (x, y) {
          return { x, y };
        }
      );
      let payingCustomersData = _.zipWith(
        kpiInfo.payingCustomers_t,
        kpiInfo.payingCustomers,
        function (x, y) {
          return { x, y };
        }
      );
      let churnData = _.zipWith(kpiInfo.churn_t, kpiInfo.churn, function (
        x,
        y
      ) {
        return { x, y };
      });
      this.churnPercentage = kpiInfo.churnPercentage;
      let data = {
        datasets: [
          {
            label: "Churn",
            data: churnData,
            backgroundColor: "#C767DC",
            borderColor: "#C767DC",
            fill: false,
          },
          {
            label: "Number of Customers",
            data: customersData,
            backgroundColor: "#E2E9FF",
            borderColor: "#6771DC",
            fill: true,
            //borderWidth: 1.8
          },
          {
            label: "Number of Paying customers",
            data: payingCustomersData,
            backgroundColor: "#A2A9F7",
            borderColor: "#A2A9F7",
            fill: false,
            borderDash: [3, 3],
            borderWidth: 0,
          },
        ],
      };
      return data;
    },
    chartOptions() {
      const self = this;
      return {
        maintainAspectRatio: this.aspectRatio,
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica-bold",
          //footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          // footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].label || "") +
                  ": " +
                  data.datasets[toolTipItem.datasetIndex].data[
                    toolTipItem.index
                  ].y || 0
              );
            },
            footer: function (toolTips, data) {
              let toolTipItem = toolTips[0];
              let value = self.churnPercentage[toolTipItem.index] || 0;
              let label = data.datasets[toolTipItem.datasetIndex].label || "";
              if (label == "Churn") {
                return `Churn % : ${value}`;
              }
            },
          },
        },
        legend: {
          position: "bottom",
          align: "end",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            //usePointStyle: true
          },
        },
        scales: {
          xAxes: [
            {
              type: "time",
              distribution: "series",
              bounds: "ticks",
              time: self.chartUnit,
              ticks: {
                source: "data",
              },
            },
          ],
        },
      };
    },
    toolTipInfo() {
      // right now just return the default (only) string
      return "Customer Growth are the KPI's added by you or updated by the portfolio company in the KPI section to the left. It is not intended to be used as a performance measurement.";
    },
    lineChartStyle() {
      return {
        position: "relative",
      };
    },
  },
  data() {
    return {
      category: {
        selected: "initial",
        title: "Time",
      },
      dataLength: 0,
      dateUnit: DAY,
      churnPercentage: [],
    };
  },
  props: {
    aspectRatio: {
      type: Boolean,
      default() {
        return false;
      },
    },
    toolTip: {
      type: String,
      default() {
        return `This chart shows the ROI of your portfolio over time.`;
      },
    },
  },
  mounted() {
    const self = this;
  },
};
</script>
<style >
</style>